import React, { useMemo } from "react";
import { AsideMenuList } from "./CustomAsideMenuList";
import { useHtmlClassService } from "../../../_core/MetronicLayout";
import { useSelector } from "react-redux";
import { SAAsideMenuList } from "./SACustomAsideMenuList";

export function AsideMenu({ disableScroll }) {
  const { user } = useSelector(({ auth }) => ({
    user: auth.user
  }));
  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      asideMenuAttr: uiService.getAttributes("aside_menu"),
      ulClasses: uiService.getClasses("aside_menu_nav", true),
      asideClassesFromConfig: uiService.getClasses("aside_menu", true)
    };
  }, [uiService]);

  return (
    <>
      {/* begin::Menu Container */}
      <div
        id="kt_aside_menu"
        data-menu-vertical="1"
        className={`aside-menu  min-h-lg-800px ${layoutProps.asideClassesFromConfig}`}
        {...layoutProps.asideMenuAttr}
      >
        {user && user.is_admin ? (
          <SAAsideMenuList layoutProps={layoutProps} />
        ) : (
          <AsideMenuList layoutProps={layoutProps} />
        )}
      </div>
      {/* end::Menu Container */}
    </>
  );
}
